/**
 * SortSelect
 * Sort-dropdown primitives: row, label, and styled <select>.
 * SortSelect / SortSelectMobile wrap the shared Select atom for backward compatibility.
 */

import styled from '@emotion/styled';
import { Select } from '../atoms/Select';
import type { SelectProps } from '../atoms/Select';
import React from 'react';

export const SortRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  @media (max-width: 900px) {
    display: none;
  }
`;

export const SortContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const SortLabel = styled.span`
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
  line-height: ${({ theme }) => theme.lineHeights[4]}px;
  color: ${({ theme }) => theme.colors.text.primary};
  padding-right: ${({ theme }) => theme.space.md};
  white-space: nowrap;
`;

const SortSelectBase = React.forwardRef<HTMLSelectElement, SelectProps>(
  function SortSelectBase(props, ref) {
    return <Select ref={ref} size="sm" fullWidth={false} {...props} />;
  }
);

export const SortSelect = styled(SortSelectBase)`
  min-width: 172px;
  border-radius: ${({ theme }) => theme.radius.small};

  @media (max-width: 900px) {
    min-width: 0;
  }
`;

/** Mobile row container — pair with SortSelectMobile (label omitted; use aria-label). */
export const SortContainerMobile = styled(SortContainer)`
  width: 100%;
`;

export const SortSelectMobile = styled(SortSelect)`
  flex: 1;
  width: 100%;
  min-width: 0;
  min-height: 44px;
`;
